var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58794 0 0 3.58794 0 8C0 12.4121 3.58794 16 8 16C12.4121 16 16 12.4121 16 8C16 3.58794 12.4121 0 8 0ZM8 1.06673C11.8356 1.06673 14.9333 4.16457 14.9333 8.00006C14.9333 11.8356 11.8355 14.9334 8 14.9334C4.16451 14.9334 1.06667 11.8356 1.06667 8.00006C1.06667 4.16457 4.16451 1.06673 8 1.06673ZM4.91667 4.43879C4.78199 4.4533 4.65774 4.51841 4.56933 4.62109C4.48093 4.72377 4.43491 4.8562 4.44061 4.99163C4.44632 5.12692 4.50324 5.25502 4.59996 5.34988L7.24444 7.99994L4.59996 10.6444C4.48972 10.7421 4.42474 10.8811 4.42065 11.0285C4.41643 11.1758 4.47348 11.3183 4.57801 11.4221C4.68268 11.526 4.82553 11.5819 4.97287 11.5766C5.12007 11.5714 5.25871 11.5054 5.35557 11.3944L8.00004 8.74994L10.6445 11.3944C10.7414 11.5054 10.88 11.5714 11.0272 11.5766C11.1745 11.5819 11.3174 11.526 11.4221 11.4221C11.5266 11.3183 11.5837 11.1758 11.5794 11.0285C11.5753 10.8812 11.5104 10.7421 11.4001 10.6444L8.75565 7.99994L11.4001 5.34988C11.5074 5.24522 11.5658 5.10013 11.5608 4.95032C11.5558 4.8004 11.4879 4.65952 11.3738 4.56217C11.2598 4.46494 11.11 4.42005 10.9611 4.43878C10.8404 4.45478 10.7286 4.51157 10.6445 4.59986L8.00007 7.24434L5.35559 4.59986C5.24188 4.48156 5.08005 4.42216 4.91674 4.43878L4.91667 4.43879Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.5cefe8e8afb6e21c05810d8de72429f4.svg";
export { ForwardRef as ReactComponent };